<template lang="pug">
  Doughnut(
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :plugins="plugins"
    :width="width"
    :height="height"
  )
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  ArcElement,
} from 'chart.js';

ChartJS.register(ArcElement);

export default {
  name: 'ChartRoundBar',
  components: { Doughnut },
  props: {
    width: {
      type: Number,
      default: 70,
    },
    height: {
      type: Number,
      default: 70,
    },
    max: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    chartId() { return this._id; }, // eslint-disable-line no-underscore-dangle
    plugins() {
      return [];
    },
    chartData() {
      return {
        datasets: [
          {
            backgroundColor: ['#19DAC6', '#E6EAED'],
            data: [this.value, this.max - this.value],
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        borderRadius: 5,
        cutout: '85%',
      };
    },
  },
};
</script>

<style scoped>

</style>
